import React from 'react';
import {Grid} from "@material-ui/core";
import {Link} from "react-router-dom";

// images
import iconBg1 from '../../../images/paystub_example.png';

import './style.scss';

const HomePaystubs = () => {
    return(
        <Grid className="OurPaystubs">
            <Grid className="container" container alignItems="center" spacing={4}>
                <Grid item xs={12} md={5}>
                    <Grid className="textContent">
                        <strong>Our Paystubs</strong>
                        <h4>Here’s What You Can Expect </h4>
                        <p>Once you’ve entered your information, you’ll be able to check out a preview of your pay stub and remittance summary. If everything looks great and you’re ready to proceed, you can download it right away, send it to yourself, and forward it to your employee. The whole process can be completed in just a few minutes.</p>
                        <Link to="/about-us" className="cBtn">Learn More</Link>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Grid className="OurPaystubsContent">
                        <div className="dstudioItem">
                            <img src={iconBg1} alt=""/>
                        </div>
                       
                     
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
};

export default HomePaystubs;